import { MenuItem, Select } from '@material-ui/core'
import Message from '../Message/Message'

interface SelectInputProps {
  name: string
  label: string
  bindValue: any
  options: any[]
  error?: string
  disabled?: boolean
}

const SelectInput = ({
  name,
  label,
  bindValue,
  options,
  error = '',
  disabled,
}: SelectInputProps) => {
  return (
    <>
      <div className={error ? 'error' : ''}>
        <label htmlFor={name}>{label}</label>
        <Select
          name={name}
          className="select"
          disableUnderline={true}
          {...bindValue}
          disabled={disabled}
          MenuProps={{
            style: { maxHeight: 240 },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
        >
          {options.map((x, index) => (
            <MenuItem key={index} value={x.value}>
              {x.label}
            </MenuItem>
          ))}
        </Select>
        {error !== '' && (
          <Message style={{ marginTop: 0 }} variant="danger">
            {error}
          </Message>
        )}
      </div>
    </>
  )
}

export default SelectInput
